import { DateDisplay } from "@covertree/types";

export const toValue = ({
  day,
  month,
  year,
}: Partial<DateDisplay> = {}): string => {
  if (!day && !month && !year) return "";
  if (day && !month && !year) return day;
  if (!day && month && !year) return month;
  if (!day && !month && year) return year;
  if (day && month && !year) return `--${month}-${day}`;
  return `${year}-${month}-${day}`;
};

export const toDisplay = (date: string | null): DateDisplay => {
  const values = date?.split("-");

  return {
    day: values?.[2] ?? "",
    month: values?.[1] ?? "",
    year: values?.[0] ?? "",
  };
};

export const prefixZero = (val = ""): string =>
  val.length === 1 ? `0${val}` : val;
